import { COUNTIES } from '@elsa/contracts';
import { useQuery } from '@tanstack/react-query';
import { rpc } from '../lib/supabase.ts';

export interface FilterOptions {
  categories: { id: number; name: string }[];
  counties: string[];
  data_from: string | null;
}

/** Categoriile si judetele pentru filtre (judetele se vad doar cu abonament). */
export function useFilterOptions() {
  return useQuery({
    queryKey: ['filter_options'],
    staleTime: 10 * 60_000,
    queryFn: () => rpc<FilterOptions>('filter_options'),
  });
}

/** Istoricul permis de plan, ca text („ultimele 90 de zile”). */
export function historyLabel(days: number | boolean | undefined): string {
  if (typeof days !== 'number') return 'tot istoricul';
  return `ultimele ${days} de zile`;
}

/** Judetele alocate unui membru: lista scurta in rezumat, bifele la deschidere. */
export function CountyPicker({
  value,
  onChange,
  disabled,
  label,
}: {
  value: string[];
  onChange: (v: string[]) => void;
  disabled?: boolean;
  label: string;
}) {
  const summary = value.length ? value.join(', ') : 'niciun județ';
  if (disabled) return <span className="text-sm">{summary}</span>;
  return (
    <details className="text-sm">
      <summary className="cursor-pointer select-none" aria-label={label}>
        {summary}
      </summary>
      <div className="mt-2 grid max-h-56 grid-cols-2 gap-x-3 gap-y-1 overflow-y-auto border border-gri-300 p-2 sm:grid-cols-3">
        {COUNTIES.map((c) => (
          <label key={c} className="flex items-center gap-1.5 whitespace-nowrap">
            <input
              type="checkbox"
              checked={value.includes(c)}
              onChange={(e) =>
                onChange(
                  e.target.checked
                    ? [...value, c].sort((a, b) => a.localeCompare(b))
                    : value.filter((x) => x !== c),
                )
              }
            />
            {c}
          </label>
        ))}
      </div>
    </details>
  );
}
